/**
 * AppLayout - Main application layout
 */

import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { TopBar } from './TopBar';

export interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Box>

      <Box
        component="footer"
        sx={{
          mt: 'auto',
          px: { xs: 2, md: 4 },
          py: 3,
          borderTop: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            gap: { xs: 1.5, sm: 3 },
            maxWidth: '100%',
          }}
        >
          <Box
            component="a"
            href="https://BrainDance.com/sitedirectory"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
          >
            <Box
              component="img"
              src="/img/bdancebanner.png"
              alt="BrainDance Family of Websites"
              sx={{ height: 90, width: 'auto', display: 'block', borderRadius: '12px' }}
            />
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              textAlign: { xs: 'center', sm: 'left' },
              fontSize: { xs: '0.875rem', sm: '1.275rem' },
              lineHeight: 1.4,
            }}
          >
            CxFab is part of the{' '}
            <Box
              component="a"
              href="https://www.braindance.com/sitedirectory"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                fontWeight: 600,
                whiteSpace: { sm: 'nowrap' },
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              BrainDance Family of Websites
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
